// Inline style reset for <button> elements. Tailwind utility classes can't
// reliably override the global styles from spicy.css and index.scss (preflight
// is disabled), so we use inline styles which always win on specificity.
// Base inline reset shared by all variants. Inline styles are needed because
// global CSS (spicy.css, index.scss) overrides Tailwind classes when preflight
// is disabled. Properties that change per-variant or per-active-state are
// merged on top of this in getTabStyle().
const BASE_RESET = {
  outline: 'none',
  appearance: 'none',
  WebkitAppearance: 'none',
  boxShadow: 'none',
  cursor: 'pointer',
};

const COLORS = {
  green: '#318616',
  grey: '#696969',
  darkGrey: '#1C1C1C',
  lightGrey: '#F5F5F5',
  border: '#E8E8E8',
  white: '#FFFFFF',
  transparent: 'transparent',
};

const VARIANT_INLINE_STYLES = {
  line: {
    base: {
      background: COLORS.transparent,
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderBottom: `3px solid ${COLORS.transparent}`,
      borderRadius: 0,
      paddingBottom: '10px',
    },
    active: {
      borderBottomColor: COLORS.green,
      color: COLORS.green,
    },
    inactive: {
      borderBottomColor: COLORS.transparent,
      color: COLORS.grey,
    },
  },
  pill: {
    base: {
      border: 'none',
      borderRadius: '9999px',
    },
    active: {
      background: COLORS.green,
      color: COLORS.white,
    },
    inactive: {
      background: COLORS.lightGrey,
      color: COLORS.grey,
    },
  },
  enclosed: {
    base: {
      border: 'none',
      borderRadius: '8px',
    },
    active: {
      background: COLORS.white,
      color: COLORS.green,
      boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
    },
    inactive: {
      background: COLORS.transparent,
      color: COLORS.grey,
    },
  },
};

export function getTabStyle(variant, isActive) {
  const v = VARIANT_INLINE_STYLES[variant] || VARIANT_INLINE_STYLES.line;
  return {
    ...BASE_RESET,
    ...v.base,
    ...(isActive ? v.active : v.inactive),
  };
}

export function getRenderTabStyle() {
  return {
    ...BASE_RESET,
    background: 'transparent',
    border: 'none',
    padding: 0,
  };
}

export const VARIANT_STYLES = {
  line: { container: '' },
  pill: { container: 'tw-gap-2' },
  enclosed: {
    container:
      'tw-border-b tw-border-solid tw-border-[#E8E8E8] tw-bg-[#FAFAFA] tw-rounded-t-lg tw-p-1',
  },
};

export const SIZE_STYLES = {
  sm: 'tw-text-[1.2rem] tw-px-3 tw-py-1.5',
  md: 'tw-text-[1.4rem] tw-px-4 tw-py-2',
  lg: 'tw-text-[1.6rem] tw-px-5 tw-py-2.5',
};

export const ALIGN_STYLES = {
  left: 'tw-justify-start',
  center: 'tw-justify-center',
  right: 'tw-justify-end',
};
